export default {
	data() {
		return {
			premiumType: '',
			premiumCardType: 'premium',
			premiumTabType: 'flight',
			formTypeMixin: 'consult',
			// showedWays: false,
		}
	},
	methods: {
		selectPremiumType(type) {
			this.premiumType = type;

			if (location.hash !== `#${type}`) {
				window.history.replaceState(null, null, window.location.pathname);
			}

			if (type === 'corporate') {
				let activePage = document.querySelector('.press-nav__item_active').innerHTML;

				if (activePage !== '1') {
					let searchParams = new URLSearchParams(window.location.search);
					searchParams.set('PAGEN_2', activePage);

					let newRelativePathQuery = `${window.location.pathname}${window.location.hash}?${searchParams.toString()}`;
					history.pushState(null, '', newRelativePathQuery);
				}
			}
		},
		toFormPixel() {
            let url = '/premium/settlement-premium-account'
            if (window.location.search) {
                url = [url, '?', location.search.substring(1)].join('');
            }
            window.location.href = url;
		},
		// showWays() {
		// 	this.showedWays = true;
		// }
	},
	mounted() {
		if (location.hash) {
			this.selectPremiumType(location.hash.slice(1));
		}
	}
}
